// 路由基础配置文件
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import base from './base'
import system from './system'
import egwBase from './egw/base'


Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [...base, ...system, ...egwBase],

    // 页面切换后滚动到顶部
    scrollBehavior: () => ({ y: 0 })
})

router.beforeEach((to, from, next) => {
  // 合规：任何路由切换都触发“个人信息保护提醒”（仅影响视觉，不阻断渲染）
  if (typeof window !== 'undefined') {
    try {
      window.dispatchEvent(new Event('lj:pip:trigger'))
    } catch (e) {}
  }
  // console.log(to, from, next)
    const title = to.meta.title
    if (title) {
        //document.title =  "龙即信息 " + title
    }

    // 获取RSA密钥
    if (process.env.NODE_ENV === 'production') {
        if (Vue.ss.get('rsaPublicKey') === null) {
            store.dispatch('GetRsaPublicKey').then()
        }
    }

    if (Vue.ss.get('token')) {
        if (to.path === '/login' || to.query.code) {
            next({ path: '/dashboard/home' })
        } else {
            if (store.getters.userId === '') {
                store.dispatch('GetUserInfo').then(() => {
                    next()
                })
            } else {
                next()
            }
        }
    } else if (to.query.code) {
        const uuid = to.query.qrcode_uuid
        const tabKey = to.query.tabKey
        if (uuid) {
            // 二维码code获取token
            store.dispatch('QrToken', { code: to.query.code, uuid }).then(() => {
                next({ path: '/', replace: true })
            })
        } else if ('2' === tabKey) {
            // 首页待阅
            store.dispatch('GetToken', to.query.code).then(() => {
                next({ path: '/?tabKey=2', replace: true })
            })
        } else {
            // ecp本身code获取token
            store.dispatch('GetToken', to.query.code).then(() => {
                next({ path: '/', replace: true })
            })
        }
    } else if (to.meta.requireAuth === false) {
        next()
    } else if (Vue.ss.get('refresh_token')) {
        store.dispatch('RefreshToken', Vue.ss.get('refresh_token')).then(() => {
            next()
        })
    } else {
        next({ path: '/login', query: { redirect: to.fullPath } })
    }
})

export default router